export const testimonials = [
  {
    id: 1,
    name: 'Lucas M.',
    role: 'Comprador Frequente',
    avatarBg: 'bg-secondary-400',
    title: 'O melhor spreadsheet que já usei',
    text: 'Encontrei tênis incríveis por metade do preço usando o CSSBuySpreadsheet. As atualizações diárias fazem toda diferença. Recomendo para quem quer comprar na China com segurança e economia.',
    stars: 5,
  },
  {
    id: 2,
    name: 'Ana R.',
    role: 'Revendedora',
    avatarBg: 'bg-accent-400',
    title: 'Mudou meu negócio completamente',
    text: 'Como revendedora, preciso de produtos de qualidade com preço baixo. O CSSBuySpreadsheet me dá acesso a fornecedores que eu nunca encontraria sozinha. As comparações entre agentes são extremamente úteis.',
    stars: 5,
  },
  {
    id: 3,
    name: 'Pedro S.',
    role: 'Entusiasta de Streetwear',
    avatarBg: 'bg-primary-400',
    title: 'Atualização diária é o diferencial',
    text: 'Já usei vários spreadsheets, mas nenhum se compara ao CSSBuySpreadsheet. A frequência de atualização e a qualidade dos links são superiores. Economizei mais de R$500 só este mês.',
    stars: 5,
  },
  {
    id: 4,
    name: 'Mariana C.',
    role: 'Compradora Iniciante',
    avatarBg: 'bg-secondary-500',
    title: 'Perfeito para iniciantes',
    text: 'Comecei a comprar da China há 3 meses e o guia CSSBuy facilitou tudo. As dicas de segurança e os tutoriais são claros e fáceis de seguir. Não me imagino comprando sem este spreadsheet.',
    stars: 5,
  },
  {
    id: 5,
    name: 'Rafael T.',
    role: 'Colecionador de Sneakers',
    avatarBg: 'bg-accent-500',
    title: 'Qualidade e variedade impressionantes',
    text: 'Minha coleção cresceu muito depois que descobri este spreadsheet. A variedade de tênis e streetwear é absurda, e os preços são os melhores que encontrei online. Vale cada clique.',
    stars: 5,
  },
  {
    id: 6,
    name: 'Juliana F.',
    role: 'Blogueira de Moda',
    avatarBg: 'bg-primary-500',
    title: 'Conteúdo sempre atualizado',
    text: 'Como blogueira, preciso estar sempre atualizada com as tendências. O CSSBuySpreadsheet me mantém à frente com produtos novos todos os dias. A seção de comparação entre agentes é meu recurso favorito.',
    stars: 5,
  },
];